import React from 'react'
import { useLocation } from 'react-router-dom'

import './Breadcrumbs.scss'

const Breadcrumbs = () => {
    const location = useLocation()
    let path: React.ReactNode[] = []
    if(location.pathname === '/'){
        path.push(<span className='current'>Home</span>)
    } else{
        path.push(<span key={"home"}>Home</span>)
        let pathWay = location.pathname.replace(' ', '').split('/');
        pathWay.forEach((item, index) => {
            if(index === pathWay.length - 1) {
                path.push(<span className='current' key={item}>{item}</span>)
            } else {
                path.push(<span key={item}> {item} / </span>)
            }
        })
    }
  return (
    <section className='breadcrumbs'>
        <div className="container">
            <p>{path.map(item => (item))} </p>
        </div> 
    </section>
  )
}

export default Breadcrumbs